/* Base */

.eds-segmented-control {
  --_track-bg: var(--eds--color--bg-muted-default);

  background-color: var(--_track-bg);
  border-radius: var(--eds--radii-full);
  box-sizing: border-box;
  display: inline-flex;
  padding: var(--eds--padding-4);
  width: fit-content;
}

/* Segments — the control paints the thumb, so each segment stays a plain tertiary button */

.eds-segmented-control--segment {
  /* Stretch Button / Tooltip trigger via their `--_width` hooks (no cross-block selectors). */
  --_width: 100%;

  border-radius: var(--eds--radii-full);
  display: flex;
  flex: 1 1 0;
  min-width: auto;
}

/* A segment with a tooltip renders a trigger around its button, so stretch whichever child it renders */

.eds-segmented-control--segment > * {
  flex: 1 1 0;
  min-width: 0;
}

/* The selected thumb is painted by the control; the tertiary button stays
   transparent and hands its interaction surface over via `--_bg-host` so hover
   and active don't paint over the thumb. */

.eds-segmented-control--segment:has([aria-pressed='true']) {
  --_bg-host: var(--eds--color--bg-base);

  background-color: var(--eds--color--bg-base);
}

/* Segment radii — a run of selected segments squares its shared edges into one pill */

.eds-segmented-control--segment--merge-start {
  border-bottom-left-radius: var(--eds--radii-none);
  border-top-left-radius: var(--eds--radii-none);
}

.eds-segmented-control--segment--merge-end {
  border-bottom-right-radius: var(--eds--radii-none);
  border-top-right-radius: var(--eds--radii-none);
}

/* Sizes */

/* The track tightens its own inset too, so an `xs` control stays compact
 * instead of spending 8px of the size it just saved on the thumb gutter. */
.eds-segmented-control--size-xs {
  min-height: var(--eds--size-24);
  padding: var(--eds--padding-2);
}

.eds-segmented-control--size-s {
  min-height: var(--eds--size-32);
}

.eds-segmented-control--size-m {
  min-height: var(--eds--size-40);
}

/* Full width */

.eds-segmented-control--full-width {
  display: flex;
  width: 100%;
}
